/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Portalnotify_LabelInputs */

const en_portalnotify_label = /** @type {(inputs: Portalnotify_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications, ${i?.count} unread`)
};

/**
* | output |
* | --- |
* | "Notifications, {count} unread" |
*
* @param {Portalnotify_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalnotify_label = /** @type {((inputs: Portalnotify_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_LabelInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_portalnotify_label(inputs)
});